import { Component, Inject } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import DOMPurify from 'dompurify';
import { QuillModule } from 'ngx-quill';
import { DialogAddCommentData } from './models/dialog-add-comment-data';

@Component({
    selector: 'app-add-comment',
    templateUrl: './add-comment.component.html',
    styleUrls: ['./add-comment.component.scss'],
    imports: [MatCardModule, MatFormFieldModule, MatInputModule, FormsModule, ReactiveFormsModule, MatButtonModule, QuillModule],
})
export class AddCommentComponent {
    /**
     * Texte saisi dans le champ commentaire.
     */
    public comment: string = '';

    /**
     * Configuration de la barre d'outils de l'editeur de texte.
     **/
    editorModules = {
        toolbar: [
            ['bold', 'italic', 'underline', 'strike'], // boutons de mise en forme
            [{ color: [] }, { background: [] }],
            [{ font: ['Arial', 'Times New Roman', 'Helvetica', 'Verdana', 'Courier New', 'monospace'] }, { size: ['10px', '18px', '32px'] }], // police et taille de la police
            [{ align: [] }, { list: 'bullet' }], // alignement du texte
        ],
    };

    /**
     * Personnalisation des polices de caratères disponibles ainsi que des tailles.
     * L'utilisation de attributors/style permet d'appliquer des styles inline aux elements plutôt que d'utiliser des * classes CSS.
     */
    customOptions = [
        {
            import: 'attributors/style/font',
            whitelist: ['Arial', 'Times New Roman', 'Helvetica', 'Verdana', 'Courier New', 'monospace'],
        },
        {
            import: 'attributors/style/size',
            whitelist: ['10px', '18px', '32px'],
        },
    ];

    /**
     * Constructeur.
     * @param dialogRef
     * @param data
     */
    constructor(
        public dialogRef: MatDialogRef<AddCommentComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogAddCommentData
    ) {}

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Annuler'.
     */
    public cancel(): void {
        this.dialogRef.close();
    }

    /**
     * Appelée lorsque l'utilisateur clique sur le bouton 'Enregistrer'.
     */
    public save(): void {
        // Sanitize le texte saisie pour eviter les attaque XSS.
        this.data.text = DOMPurify.sanitize(this.comment);
        this.dialogRef.close(this.data);
    }
}
